import { Component, Input, OnInit, ViewChild, ElementRef, SimpleChanges, OnChanges } from '@angular/core';
import { Chart, ChartDataSets, ChartType, RadialChartOptions } from 'chart.js';
import { Label } from 'ng2-charts';

@Component({
  selector: 'app-lead-type-breakdown',
  templateUrl: './lead-type-breakdown.component.html',
  styleUrls: ['./lead-type-breakdown.component.scss']
})
export class LeadTypeBreakdownComponent implements OnInit, OnChanges {
  @Input() type: string;
  @Input() total: number;
  @Input() sold: number;
  @Input() pending: number;
  @Input() lost: number;
  @ViewChild('donutChart') donutChart: ElementRef;

   radarChartOptions: RadialChartOptions = {
    responsive: true,
    cutoutPercentage: 68,
    maintainAspectRatio: true,
    events: [],
    legend: {
      display: false
    }
  };
  radarChartLabels: Label[] = [];
  radarChartData: ChartDataSets[] = [];
  colorScheme =[
    { 
      backgroundColor:["#6abb42", "#edd1ce", "#c70d0d"] 
    }
  ];
  radarChartType: ChartType = 'doughnut';


  get percentage(): number {
    return this.total ? (this.sold / this.total) * 100 : 0;
  }

  ngOnInit(): void {
    this.setChartData()
  }

  ngOnChanges(changes: SimpleChanges): void {
          this.setChartData();

  }

  setChartData() {
    this.radarChartLabels = [ this.type, `Other`];

    const soldPercentage = this.total ? (this.sold / this.total) * 100 : 0;
    const pendingPercentage = this.total ? (this.pending / this.total) * 100 : 0;
    const lostPercentage = this.total ? (this.lost / this.total) * 100 : 0;

    this.radarChartData = [{
      data: [
        soldPercentage,
        pendingPercentage,
        lostPercentage
      ], label: 'Type Percentage'
    }]
  }

} 